import {DashboardLayout} from "components/Layout";
import {isMobile} from "react-device-detect";
import {useHistory, useLocation} from "react-router-dom";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";

import {TabUserPasien} from "./TabUserPasien";
import {TabUserStaff} from "./TabUserStaff";

const findTabIndex = tab => {
	switch (tab) {
		case "dokter":
			return 1;
		case "staff":
			return 2;
		default:
			return 0;
	}
};

const findTabLabel = index => {
	switch (index) {
		case 1:
			return "dokter";
		case 2:
			return "staff";
		default:
			return "pasien";
	}
};

const UserListPage = () => {
	const history = useHistory();
	const location = useLocation();
	const activeTab = new URLSearchParams(location?.search).get("tab");
	const tab = findTabIndex(activeTab);

	const handleSelectTab = index => {
		history.push(`/user?tab=${findTabLabel(index)}`);
	};

	return (
		<DashboardLayout>
			<Tabs className="mb-0" selectedIndex={tab} onSelect={handleSelectTab}>
				<div class="" style={isMobile ? {"overflow-x": "auto", "white-space": "nowrap"} : {}}>
					<TabList className="border-0">
						<Tab>Pasien</Tab>
						<Tab>Dokter</Tab>
						<Tab>Staff</Tab>
					</TabList>
				</div>

				<div className="box-white setting-content h-100 no-border p24">
					<TabPanel>
						<TabUserPasien />
					</TabPanel>
					<TabPanel>
						<TabUserStaff roleId={2} title="Dokter" />
					</TabPanel>
					<TabPanel>
						<TabUserStaff title="Staff" />
					</TabPanel>
				</div>
			</Tabs>
		</DashboardLayout>
	);
};

export {UserListPage};
